export const COORD_TYPES = {
    POLAR: 'polar',
    CARTESIAN: 'cartesian'
};
export const DATA_TYPE = {
    FUNCTION: 'function',
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'Boolean'
};
export const SORT_ORDER_ASCENDING = 'asc';
export const SORT_ORDER_DESCENDING = 'desc';
